module.exports = __webpack_public_path__ + "img/fish2.e850ac57.png";